
/*
 * Public API Surface of mat-table-exporter
 */

export * from './lib/mat-table-exporter.module';
export { MatTableExporterDirective } from './lib/mat-table-exporter.directive';
export * from 'cdk-table-exporter';
